import { apiPath } from '../../constants';
import { axios, apiRequestOptions, transformHttpResponse } from 'utils';

export const SCHEDULE_IMPORT_VALIDATE_REQUEST = 'SCHEDULE_IMPORT_VALIDATE_REQUEST';
export const SCHEDULE_IMPORT_VALIDATE_SUCCESS = 'SCHEDULE_IMPORT_VALIDATE_SUCCESS';
export const SCHEDULE_IMPORT_VALIDATE_FAILURE = 'SCHEDULE_IMPORT_VALIDATE_FAILURE';

export const SCHEDULE_IMPORT_REQUEST = 'SCHEDULE_IMPORT_REQUEST';
export const SCHEDULE_IMPORT_SUCCESS = 'SCHEDULE_IMPORT_SUCCESS';
export const SCHEDULE_IMPORT_FAILURE = 'SCHEDULE_IMPORT_FAILURE';

/**
 * Validates a snapshot against the target competition without applying it.
 * Returns detailed match/mismatch information for the user to review.
 *
 * @param {string} competitionId
 * @param {object} snapshot  – parsed JSON from the exported .json file
 * @returns {Promise}        – resolves with the action dispatched
 */
export const validateScheduleImport = (competitionId, snapshot) => {
  return function (dispatch) {
    dispatch({ type: SCHEDULE_IMPORT_VALIDATE_REQUEST, competitionId });

    return axios(
      apiRequestOptions(
        apiPath.SCHEDULE.IMPORT_VALIDATE,
        { snapshot },
        { params: { id: competitionId } }
      )
    )
      .then(transformHttpResponse)
      .then(response => {
        const action = {
          type: SCHEDULE_IMPORT_VALIDATE_SUCCESS,
          competitionId,
          data: response.data,
        };
        dispatch(action);
        return action;
      })
      .catch(error => transformHttpResponse(error.response))
      .catch(error => {
        dispatch({ type: SCHEDULE_IMPORT_VALIDATE_FAILURE, competitionId, error });
      });
  };
};

/**
 * Applies a snapshot to the competition: overwrites settings and schedule.
 *
 * @param {string} competitionId
 * @param {object} snapshot  – parsed JSON from the exported .json file
 * @returns {Promise}        – resolves with the action dispatched
 */
export const applyScheduleImport = (competitionId, snapshot) => {
  return function (dispatch) {
    dispatch({ type: SCHEDULE_IMPORT_REQUEST, competitionId });

    return axios(
      apiRequestOptions(
        apiPath.SCHEDULE.IMPORT,
        { snapshot },
        { params: { id: competitionId } }
      )
    )
      .then(transformHttpResponse)
      .then(response => {
        const action = {
          type: SCHEDULE_IMPORT_SUCCESS,
          competitionId,
          data: response.data,
        };
        dispatch(action);
        return action;
      })
      .catch(error => transformHttpResponse(error.response))
      .catch(error => {
        dispatch({ type: SCHEDULE_IMPORT_FAILURE, competitionId, error });
      });
  };
};
